module.exports = __webpack_public_path__ + "static/media/34DSS11.eafd7f4a.jpg";